<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-25">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<pwa-appr-table-container ref="tableContainer" :scrId="scrId"></pwa-appr-table-container>
				</sf-card>
			</div>
		</div>
	</div>
</template>

<script>
import PwaApprTableContainer from './Table/PwaApprTableContainer.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			sendParam: {},
			favorite: true,
			screen: {}
		};
	},
	components: {
		PwaApprTableContainer
	},
	methods: {
		sendData(param) {
			this.sendParam = param;
		}
	}
};
</script>

<style></style>
